/* global $:false */

export default class ShoppingCart {
  constructor () {
    this.shoppingCartContainers = $('[data-shopping-cart-container]')
    this.shoppingCartMenuIcon = $('[data-shopping-cart-menu-icon]')
  }

  refreshShoppingCarts (serializedCart) {
    this.shoppingCartContainers.html(serializedCart)
  }

  refreshShoppingCartIcon (label) {
    if (label > 0) {
      this.shoppingCartMenuIcon.show()
    } else {
      this.shoppingCartMenuIcon.hide()
    }
    this.shoppingCartMenuIcon.html(label)
  }
}
